// extracted by mini-css-extract-plugin
export default {"container":"OnePanel_container__gi3sE","switchBtn":"OnePanel_switchBtn__HSaks"};